import React, { useEffect, useState } from "react";
// import Header from "../components/dashboard/header";
import Header from "./Header";
import Footer from "./Footer";
import doctorTab from "../assets/images/doctor-tab.svg";
import calenderIcon from "../assets/images/blank-notepad--content-notes-book-notepad-notebook.svg";
import circleClock from "../assets/images/circle-clock--clock-loading-measure-time-circle.svg";
import { useNavigate, Link } from "react-router-dom";
import tmdbApi from "../api/tmdbApi";
// import launchImage from '../assets/images/launch.svg';
import CPCBlock from "./quiz/CPCBlock";
import docUser from "../assets/images/doc-user.png";
import businessdeal from "../assets/images/business-handshake--deal-contract-business-money-payment-agreement.svg";
import calendar from "../assets/images/icons/calendar.svg";
import clockIcon from "../assets/images/icons/clock.svg";
import gobalLearning from "../assets/images/icons/Global-Learning-.svg";
import eyeOptic from "../assets/images/icons/Eye-Optic.svg";
import groupMeeting from "../assets/images/icons/Group-Meeting.svg";
import definitionSearch from "../assets/images/icons/Definition-Search.svg";
import calendarEdit from "../assets/images/icons/Calendar-Edit.svg";
import globalLearningbig from "../assets/images/icons/Global-Learning.svg"
import desktopFav from "../assets/images/icons/Desktop-Dollar.svg"
import chatTwo from "../assets/images/icons/Chat-Two.svg"
import leactureModule from '../assets/images/Lecture-Module.svg';
// import launchImg from '../assets/images/icons/launch-img.svg';
import sasiKiran from '../assets/images/Dr.Sasi-Kiran-Attili.svg';
import nandaKumar from '../assets/images/Dr.G.Nandakumar.svg';
import manojSingh from '../assets/images/Dr.Manoj.svg'



const CPC = () => {
    const navigate = useNavigate();
    const [quizInfo, setQuizInfo] = useState(null)
    const [isEnabled, setIsEnabled] = useState(false);
    let token = localStorage.getItem("token")

    useEffect(() => {
        // Apply background on mount
        document.body.style.background = '#FFFFFF';

        // Optional: Cleanup (revert background when component unmounts)
        return () => {
            document.body.style.background = null;
        };
    }, []);

    const checkIfExpired = (dateStr, timeStr) => {
        // Parse date and time
        const [year, month, day] = dateStr.split("-").map(Number);
        const [hour, minute] = timeStr.split(":").map(Number);

        // Create Date object assuming IST (UTC+5:30)
        const utcEnd = new Date(Date.UTC(year, month - 1, day, hour - 5, minute - 30));

        // Current time in UTC
        const nowUTC = new Date();

        return nowUTC > utcEnd;
    };


    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("");
        if (response?.result?.length > 0) {
            setQuizInfo(response?.result[0])
        }
    }

    useEffect(() => {
        if (quizInfo) {
            const checkTime = () => {
                if (!quizInfo?.scheduleate || !quizInfo?.liveStartTime || !quizInfo?.liveEndTime) return;

                const [year, month, day] = quizInfo.scheduleate.split("-").map(Number);
                const [startHour, startMinute] = quizInfo.liveStartTime.split(":").map(Number);
                const [endHour, endMinute] = quizInfo.liveEndTime.split(":").map(Number);

                // Create Date objects in IST timezone
                const toDateInIST = (h, m) => {
                    // Create a date object in local time, then shift by IST offset
                    const localDate = new Date(Date.UTC(year, month - 1, day, h - 5, m - 30));
                    return localDate;
                };

                const startTime = toDateInIST(startHour, startMinute);
                const endTime = toDateInIST(endHour, endMinute);

                const now = new Date();

                setIsEnabled(now >= startTime && now <= endTime);
            };

            checkTime(); // Initial check
            const interval = setInterval(checkTime, 30000); // Re-check every 30 seconds

            return () => clearInterval(interval);
        }
    }, [quizInfo]);


    useEffect(() => {
        window.scrollTo(0, 0);
        getCpcInfo()
    }, []);
    const handelnavigation = (userType) => {
        localStorage.setItem('userType', userType)
        navigate("/signup")
    }

    const join = () => {
        if (isEnabled) {
            window.open(quizInfo?.meetingLink, '_blank');
        } else {
            navToQuiz();
        }
    }

    const login = () => {
        if (token) {
            navigate("/studentcpc")

        } else {
            localStorage.setItem('userType', "STUDENT")
            localStorage.setItem("cpcid", quizInfo?.cpcid)

            navigate("/login")
        }


    }

    const displayDate = (date) => {
        const formattedDate = new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate;

    }

    const convertToAMPM = (time24) => {
        const [hour, minute] = time24.split(":").map(Number);
        const date = new Date();
        date.setHours(hour);
        date.setMinutes(minute);

        return date.toLocaleTimeString('en-IN', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };


    const navToQuiz = async () => {

        const response = await tmdbApi.quizInfoId(quizInfo.quizId);
        if (response?.result) {
            let data = response.result[0];
            localStorage.setItem('q', JSON.stringify(data))

            navigate({
                pathname: "/quiz",
                state: { data }
            });
        }

    }
    return (
        <>

            <Header />
            <style>
                {`
                body{
                    background: #FFFFFF !important;}
                }`}
            </style>

            <div className="cpc-bg">

                <section className="about-us-section text-center bg-light">
                    <div className="container">
                        <h3 className="txt-48">CPC</h3>
                        <p className="txt-16 text-muted cpc-head-para">Clinical insights. Pathological clarity. Collaborative learning. Empowering medical professionals <br></br> for accurate diagnoses and better patient outcomes worldwide.</p>
                    </div>
                </section>



                <div className="row container-fluid gap-5 cpc-table cpc-page mt-5 mb-5" id="cpc-table">

                    {doctorTab && <CPCBlock img={doctorTab} table={true} />}
                   
                </div>

                <div className="container cpc-hero mt-5 mb-5 pt-5 p-4 pb-1 pe-4">
                    <section className="container mb-5">
                        <div className="row align-items-center">
                            <div className="col-lg-7 col-md-12 d-flex flex-column justify-content-center">
                                <div className="hero-text-box pe-md-4">
                                    <h2>Elevate Your Dermatopathology Skills with India’s Best!</h2>
                                    <p className="mt-4 mb-0"><strong>Join Free Monthly Sessions Led by Experts</strong></p>
                                    <p className="pe-md-3 ">Join hundreds of dermatologists at our inaugural CPC! This is your opportunity to engage in enriching academic conversations, review real-world cases, and refine your diagnostic skills. Become part of a nationwide network of medical professionals dedicated to excellence in dermatopathology education. These sessions are designed to elevate your clinical acumen, connect you with thought leaders in the field, and foster continuous growth.</p>
                                    {/* <div className="mt-4">
                                        <h6 className="video-txt text-start"><strong>Launch CPC Session</strong></h6>
                                        <div className="mb-1"><strong>Date:</strong> June 25, 2025</div>
                                        <div><strong>Time:</strong> 3:30–4:30 PM IST</div>
                                        <p className="mt-2">Don’t Miss the Kickoff Event in Just <span id="countdown">20</span> Days!</p>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-5 learning-hub-section cpc-cards mt-4">

                                <div className="col-lg-12 explore-box mt-5 mt-lg-0">
                                    <div className="explore-card card-green">
                                        <h6 className="lecture-txt text-start">INR 5000</h6>
                                        <p className="text-start win-module">Win Module Access</p>
                                        <p className="text-start win-text mt-2">Take part in our Pre-CPC Quiz and stand a chance to win free access to premium dermatopathology
                                            learning modules. Sharpen your skills, test your knowledge, and join the elite!</p>
                                        {/* <p className="lec-badge text-start">Win Module Access</p> <br></br> */}



                                        <div className="lecture-img">
                                            <img src={leactureModule} alt="lecture-module-img" />
                                        </div>
                                    </div>
                                    <div>
                                    {/* <p className="text-center">No registration fee. No strings. Just learning.</p> */}

                                    </div>
                                    {/* <div className="explore-card card-orange">
                                        <h6 className="video-txt text-start">Launch CPC Session</h6>
                                        <div className="mb-2"><strong>Date:</strong> June 25, 2025</div>
                                        <div><strong>Time:</strong> 3:30–4:30 PM IST</div>
                                        <p className="mt-2">Don’t Miss the Kickoff Event in Just <span id="countdown">20</span> Days!</p>
                                        <div className="video-module">
                                            <img src={launchImg} alt="video-module-img" />
                                        </div>

                                    </div> */}

                                </div>
                            </div>
                        </div>
                    </section>
                </div>


                <section className=" mt-5 mb-5 ">
                    <div className="container">
                        <div className="text-center mb-4">
                            <h3>Why Join DADI CPCs?</h3>
                            <p className="mt-3">
                                Experience transformative dermatopathology education with DADI
                                <br />
                                (Dermpath Academy and Diagnostics India Pvt Ltd). Our free monthly CPCs offer
                            </p>
                        </div>
                        <div className="d-flex flex-wrap col-lg-12 justify-content-center why-join-resp ms-4 mb-5 gap-3" id="why-join-dadi-resp">
                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item ">
                                <img
                                    src={chatTwo}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Complex Case Discussions</b>
                                    <p className="mt-1 mb-0">Analyze real cases with scanned slides, led by top experts.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item ">
                                <img
                                    src={desktopFav}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Interactive Quizzes</b>
                                    <p className="mt-1 mb-0">Test your knowledge and win exciting prizes.</p>
                                </div>
                            </div>


                            <div className="col-lg-3 col-md-4 col-sm-5 feature-item why-cpc-item ">
                                <img
                                    src={globalLearningbig}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Global Community</b>
                                    <p className="mt-1 mb-0">Connect with India’s dermatology elite via Zoom.</p>
                                </div>
                            </div>
                        </div>






                    </div>


                </section>

                <section className=" mt-5 why-join pt-5 pb-5">
                    <div className="container">
                        <div className="text-center mb-4">
                            <h3>Meet Your CPC Leaders</h3>
                        </div>

                        <div className="row col-lg-12 meet-your-resp justify-content-center mt-3 gap-3">
                            <div className="col-lg-3 col-md-4 col-sm-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={sasiKiran}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. Sasi Kiran Attili</b>
                                    <p className="mt-1 mb-0">Editor-in-Chief of Indian Journal of Dermatopathology & Diagnostic Dermatology, National Quiz Master, with over 150+ presentations.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={nandaKumar}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. G. Nandakumar</b>
                                    <p className="mt-1 mb-0">Award-winning educator (IADVL Best Teacher 2024), with 200+ presentations.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-3 text-center feature-item why-cpc-item why-cpc-item1 doc-user">
                                <img
                                    src={manojSingh}
                                    alt="Icon"
                                    className="feature-icon mb-3"
                                />
                                <div className="feature-text">
                                    <b>Dr. Manoj Singh</b>
                                    <p className="mt-1 mb-0">Founder of India’s first dermatopathology lab at AIIMS, B C Roy Award recipient.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className=" mt-5 pb-5">
                    <div className="container justify-content-center">
                        <div className="text-center mb-4">
                            <h3>What to Expect?</h3>
                        </div>

                        <div className="row justify-content-center mt-5 gap-3 expect-cards-resp">
                            <div className="col-lg-3 col-md-3 col-sm-2 text-center d-grid align-items-center justify-content-center  gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={gobalLearning} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Case-Based Learning</b>
                                    <p className="mt-1 mb-0">Dive into real-world dermatopathology <br></br>  cases.</p>
                                </div>
                            </div>



                            <div className="col-lg-3 col-md-3 col-sm-2 text-center d-grid align-items-center justify-content-center gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={calendarEdit} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Engagement</b>
                                    <p className="mt-1 mb-0">Participate in live Q&As and quizzes with exciting <br></br> prizes.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-2 text-center d-grid align-items-center justify-content-center  gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={definitionSearch} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Flexibility</b>
                                    <p className="mt-1 mb-0">Learn at your own pace with free access to live <br></br> sessions.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-2 text-center d-grid align-items-center justify-content-center gap-2 feature-item why-cpc-item1">
                                <div className="d-flex justify-content-center">
                                    <span className="material-symbols-outlined arrow">
                                        <img src={groupMeeting} width={26} alt="" />
                                    </span>
                                </div>
                                <div className="feature-text">
                                    <b>Expert Insights</b>
                                    <p className="mt-1 mb-0">Gain practical knowledge from India’s top dermatopathologists.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* <!-- Community Section --> */}
                    {/* <section className="community-banner text-center">
                        <div className="container">
                            <h3 className="fw-bold">Join hundreds of dermatologists at our inaugural CPC!</h3>
                            <p className="text-muted">Be part of a growing community advancing dermatopathology education across India.</p>
                        </div>
                    </section> */}
                </section>






                <section className="cpc-description-section py-5 d-none" id="pageContent">
                    <div className="container d-flex flex-column align-items-center text-center">
                        {/* <img src={errorImg} alt="CPC Coming Soon" className="img-fluid mb-4" style={{ maxWidth: "300px" }} /> */}
                        <h4 className="mb-3">CPC (Clinical-Pathological Correlation) Sessions</h4>
                        <p className="mb-4" style={{ maxWidth: "800px", lineHeight: "1.8", fontSize: "16px" }}>
                            Our CPC (Clinical-Pathological Correlation) sessions provide a unique learning opportunity for pathologists,
                            clinicians, and medical professionals. These interactive sessions enable in-depth discussions of real patient cases,
                            integrating clinical information with pathological findings to foster a holistic understanding of diagnosis and treatment.
                        </p>
                        <ul className="text-start" style={{ maxWidth: "800px", fontSize: "16px", lineHeight: "1.8" }}>
                            <li><strong>Collaborate with Experts:</strong> Join a community of medical professionals to discuss real cases and gain insights from leading experts in dermatopathology.</li>
                            <li><strong>Improve Diagnostic Skills:</strong> Engage in detailed analysis of clinical data and histopathological images, honing your ability to make accurate, informed diagnoses.</li>
                            <li><strong>Learn through Case-Based Discussions:</strong> Each CPC session is designed to challenge your thinking and expand your understanding of complex cases.</li>
                            <li><strong>Enhance Patient Care:</strong> Improve your ability to correlate clinical and pathological findings, contributing to better patient outcomes.</li>
                        </ul>
                    </div>
                </section>
                <div className="service-link d-none">
                    {/* <button className="btn-stroke-icon mt-5" onClick={(e) => handelnavigation3()}>

                                <p>Lecture Library</p></button>
                            <span className="material-symbols-outlined arrow_forward_fill">arrow_forward_ios</span> */}
                    <button className="btn-fill-icon mt-5" onClick={(e) => handelnavigation("Clinician")}><span className="material-symbols-outlined btn-icon-fill-style">
                        keyboard_arrow_right
                    </span>Lecture Library</button>
                    <button className="btn-fill-icon mt-5" onClick={(e) => handelnavigation("Student")}><span className="material-symbols-outlined btn-icon-fill-style">
                        keyboard_arrow_right
                    </span>CPC</button>
                </div>

            </div>


            <Footer />
        </>
    );
};

export default CPC;

